import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { EditorialRecipeReaderV2 } from "@/components/editorial-v2/EditorialRecipeV2";

/** One published RECIPE from an existing paid BookPage, never an author draft. */
export default function RecipeOnlyReader() {
  const { slug, pageId, blockId } = useParams();
  const nav = useNavigate();
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let alive = true;
    setData(null);
    setError("");
    api.get(`/book/${encodeURIComponent(slug)}/pages/${encodeURIComponent(pageId)}/recipes/${encodeURIComponent(blockId)}`)
      .then(({ data: result }) => {
        if (alive && result?.recipe?.id === blockId && result.recipe.master_type === "RECIPE") setData(result);
        else if (alive) setError("Рецептура недоступна.");
      })
      .catch(() => { if (alive) setError("Рецептура недоступна или нет доступа к Тому."); });
    return () => { alive = false; };
  }, [slug, pageId, blockId]);

  const back = () => nav(`/book/${encodeURIComponent(slug)}/pages/${encodeURIComponent(pageId)}${searchParams.get("from") === "tome-owner" ? "?from=tome-owner" : ""}`);
  return (
    <main className="min-h-screen bg-[#F4EBDD] px-5 py-8 text-[#3b241a]" data-testid="book-recipe-only-reader">
      <div className="mx-auto mb-8 max-w-[860px]">
        <button type="button" onClick={back} className="rounded-lg border border-[#9D8268]/40 px-4 py-2 text-sm"
          data-testid="book-recipe-only-back">К полной главе</button>
      </div>
      {error ? <p role="alert" className="mx-auto max-w-[860px]">{error}</p> : !data ? (
        <p className="mx-auto max-w-[860px]">Загрузка рецептуры…</p>
      ) : (
        <>
          <div className="hidden lg:block"><EditorialRecipeReaderV2 block={data.recipe} mode="desktop" /></div>
          <div className="lg:hidden"><EditorialRecipeReaderV2 block={data.recipe} mode="mobile" /></div>
        </>
      )}
    </main>
  );
}
